import { Api } from '@/services/Api'
import store from "@/store/index"
const momentTz = require('moment-timezone')

export default {
  getPlantList () {
    return Api().get(`/api/v2/plant-analytics/plant`)
  },
  getPlantEquipmentList (plantId, level) {
    return Api().get(`/api/v2/plant-analytics/${plantId}/${level}`)
  },
  getDeviceList (payload) {
    return Api().post('/api/v2/plant-analytics/device-list', payload)
  },
  getPlantData(param) {
    return Api().post('/api/v2/plant-analytics/data', param)
  },
  getPlantTableData(param) {
    return Api().post('/api/v2/plant-analytics/table', param)
  },
  downloadPlantTableData(key) {
    return Api().request({
      url: '/api/v2/plant-analytics/download/' + key,
      method: 'GET',
      responseType: 'blob',
      timeout: 100000
    }).then((response) => {
      const tz = store.getters.getGeneralState('activePlant').timezone
      const filename = `analytics-${momentTz().tz(tz).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  },
  insertTemplates(param) {
    return Api().post(`api/v2/plant-analytics/template`, param)
  },
  fetchTemplate(userId) {
    return Api().get(`api/v2/plant-analytics/template/${userId}`)
  },
  deleteTemplate(id) {
    return Api().delete(`api/v2/plant-analytics/template/${id}`)
  },
  fetchParameterOrder(userId) {
    return Api().get(`api/v2/plant-analytics/order/${userId}`)
  }
}
